/* src/app/shared/components/date-picker/date-picker.component.css */
:host ::ng-deep .custom-calendar-panel {
  width: 300px !important;
  min-width: 250px;
  font-size: 13px;
  padding: 0.5rem 0.75rem;
}
:host ::ng-deep .custom-calendar-panel .p-datepicker-calendar td {
  padding: 2px 4px !important;
  height: 30px;
  width: 30px;
}
:host ::ng-deep .custom-calendar-panel .p-datepicker-calendar {
  margin: 0;
}
:host ::ng-deep .custom-calendar-panel .p-datepicker {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
}
:host ::ng-deep .custom-calendar-panel .p-datepicker-calendar td > span {
  line-height: 28px;
  font-size: 13px;
  width: 28px;
  height: 28px;
}
:host ::ng-deep .p-calendar {
  width: 100%;
  height: 32px;
}
:host ::ng-deep .p-calendar .p-inputtext {
  width: 100%;
  font-size: 14px !important;
}
:host ::ng-deep .disabled-calendar .p-calendar .p-inputtext {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.4);
}
:host ::ng-deep .p-inputtext:hover {
  border-color: #40a9ff !important;
  border-right-width: 1px;
}
.p-inputtext {
  border: 1px solid #d9d9d9;
  border-radius: 6px !important;
  padding: 4px 11px !important;
  font-size: 14px !important;
  line-height: 1.5715 !important;
  transition: all 0.3s !important;
}
:host ::ng-deep .p-inputtext:focus,
:host ::ng-deep .p-inputwrapper-focus .p-inputtext {
  border-color: #4096ff !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  outline: none !important;
}
:host ::ng-deep .p-inputtext:disabled {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}
:host ::ng-deep p-calendar .p-inputtext::placeholder {
  color: #bfbfbf !important;
  opacity: 1;
}
:host ::ng-deep .p-input-icon-right > .p-icon-wrapper {
  color: #bfbfbf !important;
}
:host ::ng-deep .p-calendar .p-button {
  background-color: none;
  color: #4096ff;
  text-decoration: underline;
}
.p-datepicker-calendar .custom-focus {
  outline: 2px solid #007ad9 !important;
  outline-offset: 2px !important;
  background-color: #e3f2fd !important;
}
.p-datepicker-calendar span[aria-selected=true] {
  background-color: #007ad9 !important;
  color: white !important;
}
/*# sourceMappingURL=date-picker.component-6AQK27CP.css.map */
